import { createContext } from 'react';
import { useFeed, UseFeedProps } from '../hooks/useFeed';
import { PostsFeed } from '../types';

export const FeedContext = createContext<PostsFeed>({ Everyone: [] });

export const FeedProvider = ({ sources, onNewPost, children }: React.PropsWithChildren<UseFeedProps>) => {
    const bonk = useFeed({
        sources,
        onNewPost,
    });

    return <FeedContext.Provider value={bonk}>{children}</FeedContext.Provider>;
};
